import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import {
  setStore, QueryClient, QueryClientProvider, ReduxContext,
  LazyTableClient, LazyTableProvider,
} from '@platform/rcl';
// Override because the file extension is required in this case
// eslint-disable-next-line import/extensions
import App from './App.jsx';
import store from './store';
import '../../sass/app.scss';

require('@platform/rcl/dist/global.css');

const queryClient = new QueryClient();
const lazyTableClient = new LazyTableClient();
setStore(store);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store} context={ReduxContext}>
    <QueryClientProvider client={queryClient}>
      <LazyTableProvider client={lazyTableClient} contextSharing>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </LazyTableProvider>
    </QueryClientProvider>
  </Provider>,
);
